import { motion } from 'framer-motion';
import styled from 'styled-components';

export const MainNavigationItemWrapper = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    position: relative;
`;

export const MainNavigationItemLabelWrapper = styled.div`
    position: absolute;
    transform: translateY(-100%);
    top: 0;
`;

export const MainNavigationItemLabel = styled(motion.div)`
    padding: 4px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    text-transform: uppercase;
`;
